import { FormattedMessage, FormattedNumber } from '@liveauctioneers/hammer-ui-core/intl';
import React, { ReactElement } from 'react';

export type ResultsCountProps = {
    isPriceResults?: boolean;
    totalFound: number;
};

const MAX_PRICE_RESULTS_COUNT = 10000;

const ResultsCount = ({ isPriceResults = false, totalFound }: ResultsCountProps): ReactElement => {
    return isPriceResults && totalFound > MAX_PRICE_RESULTS_COUNT ? (
        <FormattedMessage id="searchPage.10kPlusResults" />
    ) : (
        <FormattedMessage
            id="searchPage.resultsCount"
            values={{
                formattedNumber: (
                    <FormattedNumber
                        key="formatted_number"
                        value={totalFound}
                    />
                ),
                totalFound,
            }}
        />
    );
};

export default ResultsCount;
